
import SimpleHeader from "components/Headers/SimpleHeader.jsx";
import React from "react";
import {
    Button,
    Card,
    CardBody,
    CardHeader, Col,
    Container,
    Form, FormGroup, Row
} from "reactstrap";
import AdminService from "../../../services/adminService";
import AdminForm from "./Form";
import TenantService from "../../../services/tenantService";
import FormInput from "../../../components/common/form/FormInput";
import NotificationAlert from "react-notification-alert";
import Loader from "../../Loader";
import DownloadUtil from "../../../util/downloadUtil";
import _ from "lodash";
import UtilService from "../../../services/utilService";

class AdminEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errorData: {},
            file:undefined,
            loading:false,
            selectKey: UtilService.uuidv4()
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.updateBrandLogo = this.updateBrandLogo.bind(this);
        this.handleCountrySelectChange = this.handleCountrySelectChange.bind(this);
    }

    componentDidMount() {
        this.loadInitialData()
    }

    loadInitialData = () => {
        const {uniqueId} = this.props.match.params;
        AdminService.fetch(uniqueId).then(response => {
            this.setState(response.data);
            this.setState({adminRole: response.data.role[0]});
            this.setState({uniqueId: uniqueId});
            const selectedCountries = _.map(response.data.allowedCountries, country => {
                return {
                    key : country,
                    value:country
                }
            })
            console.log(selectedCountries)
            this.setState({selectedCountries:selectedCountries, selectKey: UtilService.uuidv4()})
        });
    }



handleCountrySelectChange(valueObj) {
    console.log(valueObj)
    if (_.isNull(valueObj)) {
        this.setState({selectedCountries: {}, allowedCountries: []});
    } else {
        const countries =  _.map(valueObj, "key")
        console.log(countries)
        this.setState({selectedCountries: valueObj, allowedCountries: countries});
    }
}

    handleChange(event) {
        if(event.target.type === "checkbox") {
            this.setState({[event.target.name]: event.target.checked});
        } else{
            this.setState({[event.target.name]: event.target.value});
        }
    }

    handleSubmit(event) {
        event.preventDefault();
        this.setState({loading: true})
        AdminService.update(this.state).then(response => {
            console.log(response.data);
            if (response.responseStatus === "SUCCESS") {
                this.props.history.push("/crm/list");
            } else {
                this.setState({errorData: response.data});
                console.error("Error    ==>     " + response.message);
            }
            this.setState({loading: false})
        });
    }

    notify = (type, title, message) => {
        let options = {
            place: "tc",
            message: (
                <div className="alert-text">
          <span className="alert-title" data-notify="title">
            {title}
          </span>
                    <span data-notify="message">{message}</span>
                </div>
            ),
            type: type,
            icon: "ni ni-bell-55",
            autoDismiss: 5,
        };
        this.refs.notificationAlert.notificationAlert(options);
    };


    updateBrandLogo(event){
        event.preventDefault();
        this.setState({loading: true})
        const data = new FormData()
        data.append('file', this.state.file)
        data.append('uniqueId', this.props.match.params.uniqueId);
        console.log(data);
        AdminService.uploadLogo(data).then((response) => {
            console.log(response);
            if (response.responseStatus === "SUCCESS") {
                this.loadInitialData()
                this.notify("success", "Upload Successful", "Brand Logo uploaded successfully!")

            } else {
                this.notify("danger", "Upload Unuccessful", "Brand Logo not uploaded successfully!")
                console.error("Error    ==>     " + response.message);
            }

            this.setState({loading: false})
        });
    }

    fileChange = (event) => {
        this.setState({file: event.target.files[0]})
    };


    render() {
        return (
            <>
                <SimpleHeader
                    name="Edit"
                    parentName="User"
                    heading="ClashMate"
                    newBtnUrl="/crm/create"
                    newBtnText="Create User"
                />
                <div className="rna-wrapper">
                    <NotificationAlert ref="notificationAlert" />
                </div>
                <Container className="mt--6" fluid>
                    {this.state.loading && <Loader />}
                    <Card className="mb-4">
                        <CardHeader>
                            <h3 className="mb-0">Edit User</h3>
                        </CardHeader>
                        <CardBody>
                            <Form role="form" onSubmit={this.handleSubmit}>
                                <AdminForm
                                    selectKey = {this.state.selectKey}
                                    onChange={this.handleChange}
                                    valueObj={this.state}
                                    errorObj={this.state.errorData}
                                    isEdit={true}
                                    selectedRole = {this.state.adminRole}
                                    handleCountrySelectChange = {this.handleCountrySelectChange}
                                    selectedCountries = {this.state.selectedCountries}
                                />
                                <div className="text-center">
                                    <Button className="my-4" color="default"  outline type="submit">
                                        Update
                                    </Button>
                                </div>
                            </Form>
                        </CardBody>
                    </Card>
                </Container>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <Container className="mt--6" fluid>
                    <Row>
                        <Col md="6" sm="6">
                            <Card className="mb-4">
                                <CardHeader>
                                    <h3 className="mb-0">Upload Brand Logo</h3>
                                </CardHeader>
                                <CardBody>


                                    <Col md="6" sm="12">
                                        <FormGroup>
                                            <label className="form-control-label" htmlFor="example4cols3Input">
                                                Brand Logo
                                            </label>
                                            <span><img style={{width: "100%"}} src={DownloadUtil.generateUrl(this.state.brandLogoUID)} alt={"Brand Logo Not Uploaded"}/></span>
                                        </FormGroup>
                                    </Col>
                                    <Col md="12" sm="12">
                                        <Form role="form" onSubmit={this.updateBrandLogo}>
                                            <FormInput
                                                name="file"
                                                className="form-control-label custom-file-input"
                                                id="file"
                                                placeholder="inputPlaceHolder.notice.files"
                                                type="file"
                                                onChange={this.fileChange}
                                                label="Browse"
                                                multiple={false}
                                                key={this.state.fileSelectUUID}
                                                isEdit
                                                // value={this.props.valueObj.firstName || ""}
                                                // errorMsg={this.props.errorObj.firstName || ""}
                                            />
                                            <span
                                                className="badge badge-pill badge-primary">{this.state?.file?.name}</span>
                                            <div className="text-center">
                                                <Button className="my-4" color="default" outline type="submit">
                                                    Submit
                                                </Button>
                                            </div>
                                        </Form>
                                    </Col>




                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </>
        );
    }
}

export default AdminEdit;
